jQuery(function () {
  const selector = '[data-behaviour~="rsvp-invite"]';

  // BEHAVIOUR

  jQuery(document).on("click", selector, handleClick);

  // HELPER FUNCTIONS

  async function handleClick(event) {
    event.preventDefault();

    const $trigger = jQuery(this);
    const modal = document.querySelector("sp-rsvp-invite-app");
    const whenMountReady = window.Sparkle?.CustomElements?.whenMountReady;
    if (!modal || !whenMountReady) {
      return;
    }

    // `open()` exists only post-mount — await the mount-ready contract.
    try {
      await whenMountReady(modal);
    } catch (error) {
      console.error("sp-rsvp-invite-app failed to load; the RSVP invite modal is unavailable", error);
      return;
    }

    const config = {};
    const eventId = $trigger.data("event-id");
    const previewUrl = $trigger.data("preview-url");
    const processUrl = $trigger.data("process-url");
    const addAttendeeUrl = $trigger.data("add-attendee-url");

    if (eventId) {
      config.eventId = Number(eventId);
    }
    if (previewUrl) {
      config.previewUrl = previewUrl;
    }
    if (processUrl) {
      config.processUrl = processUrl;
    }
    if (addAttendeeUrl) {
      config.addAttendeeUrl = addAttendeeUrl;
    }

    modal.open(config);
  }
});
